import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';

import { AuthUserMapper, IAuthUser } from '@modules/auth';
import { bind } from '@infra/container';

export type GetAuthUserRepoResponse = IRepoResponse<200, IAuthUser> | IRepoResponse<400 | 500, string>;

export type IGetAuthUserRepo = IRepo<[], GetAuthUserRepoResponse>;

export const GetAuthUserRepoType = Symbol.for('GetAuthUserRepo');

@bind(GetAuthUserRepoType)
export class GetAuthUserService implements IGetAuthUserRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute() {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/client/user') });

      if (result.status === 200) {
        const mappedResponse = AuthUserMapper.toDomain(result.data);

        return {
          status: 200 as 200,
          response: mappedResponse,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
